import h from "trader-hyperscript";
import * as routes from "../../routes";
import * as style from "../../../styles/style.css.classes";
import {
  formulaid,
  instrumentid,
  internalteacherid,
  roomid,
} from "../../../sql/classy/types";
import { Form, checkBox, constantField, textBox } from "trader.ts/ui.forms";
import { renderDeleteButton, renderSaveButton } from "../../client/savebutton";
import { rpc } from "trader.ts/network";
import {
  checkboxesField,
  wrapSelectboxesInPanel,
} from "../../client/checkboxesfield";
import { renderFirstNameLastName } from "../../render";
import { mandatoryValidation } from "../../lib/validate";

export function render(opts: {
  instrument: null | {
    id: instrumentid;
    description: string;
    showonpublicplanning: boolean;
    private_waitinglist_active: boolean;
  };
  formulas: {
    id: formulaid;
    description: string;
    instruments: instrumentid[] | null;
  }[];
  rooms: {
    id: roomid;
    description: string;
    instruments: { instrumentid: instrumentid }[] | null;
  }[];
  teachers: {
    internalteacherid: internalteacherid;
    firstname: string;
    lastname: string;
    instruments: { id: instrumentid }[] | null;
  }[];
}): HTMLElement | HTMLElement[] {
  const instrument = opts.instrument;

  const form = new Form({})
    .addField("id", [], () => constantField(opts.instrument?.id ?? null))
    .addField("description", [], () =>
      textBox({
        initialVal: instrument?.description || "",
        label: "Naam",
        validations: [mandatoryValidation],
      }),
    )
    .addField("showonpublicplanning", [], () =>
      checkBox({
        label: "Toon cursus op publieke inschrijvingen",
        class: style.input_like + style.checkbox,
        initialVal: instrument?.showonpublicplanning ?? true,
      }),
    )
    .addField("teachers", [], async () =>
      checkboxesField({
        initial: instrument
          ? opts.teachers.filter((t) =>
              (t.instruments || []).some((i) => i.id === instrument.id),
            )
          : [],
        values: opts.teachers.orderBy(renderFirstNameLastName),
        show: renderFirstNameLastName,
        addNoFilterOption: false,
        addAllOption: true,
      }),
    )
    .addField("rooms", [], async () =>
      checkboxesField({
        initial: instrument
          ? opts.rooms.filter((t) =>
              (t.instruments || []).some(
                (i) => i.instrumentid === instrument.id,
              ),
            )
          : [],
        values: opts.rooms.orderBy((r) => r.description),
        show: (r) => r.description,
        addNoFilterOption: false,
        addAllOption: true,
      }),
    )
    .addField("formulas", [], async () =>
      checkboxesField({
        initial: instrument
          ? opts.formulas.filter((t) =>
              (t.instruments || []).some((i) => i === instrument.id),
            )
          : [],
        values: opts.formulas.orderBy((f) => f.description),
        show: (r) => r.description,
        addNoFilterOption: false,
        addAllOption: true,
      }),
    )
    .addField("private_waitinglist_active", [], () =>
      constantField(instrument ? instrument.private_waitinglist_active : false),
    )
    .build({
      render: (fields) => (
        <div>
          {fields.description()}

          {fields.showonpublicplanning()}

          <div className={style.equal_columns}>
            {wrapSelectboxesInPanel(
              "Docenten die deze cursus geven",
              fields.teachers(),
            )}
            {wrapSelectboxesInPanel(
              "Lokalen waar deze cursus kan doorgaan",
              fields.rooms(),
            )}
          </div>
          <div className={style.equal_columns}>
            {wrapSelectboxesInPanel(
              "Formules voor deze cursus",
              fields.formulas(),
            )}
            <div></div>
          </div>
        </div>
      ),
    });

  return (
    <div>
      <div>{form.render()}</div>
      <div style="text-align: right">
        {instrument !== null ? (
          renderDeleteButton({
            label: "Verwijder cursus",
            confirmationLabel: "Ben je zeker dat je deze cursus wilt verwijderen?",
            doDelete: function () {
              return rpc(routes.deleteInstrumentSpec, undefined, {
                instrumentid: instrument.id,
              });
            },
            redirectTo: routes.config_instrumentslistRoute.link(),
          })
        ) : (
          <span></span>
        )}

        {renderSaveButton({
          formS: form.s,
          save: async function (instr) {
            const res = await rpc(routes.saveInstrumentSpec, undefined, {
              id: instr.id,
              description: instr.description,
              showonpublicplanning: instr.showonpublicplanning,
              teachers: instr.teachers.map((t) => t.internalteacherid),
              formulas: instr.formulas.map((f) => f.id),
              rooms: instr.rooms.map((r) => r.id),
              private_waitinglist_active: instr.private_waitinglist_active,
            });
            if ("tag" in res && res.tag === "success") {
              return {
                ...res,
                redirectUrl: routes.config_instrumentslistRoute.link(),
              };
            }
            return res;
          },
          reload: false,
        })}
      </div>
    </div>
  );
}
